import React from 'react';
import { diffLines, diffWordsWithSpace } from 'diff';

const boxStyle = {
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  margin: 0,
  padding: 12,
  borderRadius: 6,
  fontSize: 13,
  lineHeight: 1.55,
  maxHeight: 'min(58vh, 520px)',
  overflow: 'auto',
  border: '1px solid #e8e8e8',
  background: '#fafafa',
  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
};

function buildParts(oldStr, newStr) {
  const oldNl = oldStr.match(/\n/g)?.length ?? 0;
  const newNl = newStr.match(/\n/g)?.length ?? 0;
  if (oldNl + newNl < 6) {
    return diffWordsWithSpace(oldStr, newStr);
  }
  return diffLines(oldStr, newStr, { newlineIsToken: true });
}

export default function FieldHistoryDiff({ oldValue, newValue }) {
  const oldStr = oldValue == null ? '' : String(oldValue);
  const newStr = newValue == null ? '' : String(newValue);

  const emptyOld = oldStr.length === 0;
  const emptyNew = newStr.length === 0;

  if (emptyOld && emptyNew) {
    return (
      <pre style={{ ...boxStyle, color: '#888' }}>
        (empty)
      </pre>
    );
  }

  if (oldStr === newStr) {
    return (
      <pre style={{ ...boxStyle, borderColor: '#b7eb8f', background: '#f6ffed' }}>
        {newStr || '(empty)'}
      </pre>
    );
  }

  const parts = buildParts(oldStr, newStr);

  return (
    <>
      <p style={{ marginBottom: 8, fontSize: 12, color: '#666' }}>
        <span style={{ background: '#d1f7c4', padding: '1px 6px', borderRadius: 4, marginRight: 8 }}>
          Added
        </span>
        <span style={{ background: '#ffd7d5', padding: '1px 6px', borderRadius: 4 }}>
          Removed
        </span>
      </p>
      <pre style={boxStyle} aria-label="Unified text diff">
        {parts.map((part, i) => {
          if (part.added) {
            return (
              <span
                key={i}
                style={{
                  background: '#d1f7c4',
                  color: '#1a3d0a',
                }}
              >
                {part.value}
              </span>
            );
          }
          if (part.removed) {
            return (
              <span
                key={i}
                style={{
                  background: '#ffd7d5',
                  color: '#5c1a18',
                  textDecoration: 'line-through',
                }}
              >
                {part.value}
              </span>
            );
          }
          return (
            <span key={i} style={{ color: '#374151' }}>
              {part.value}
            </span>
          );
        })}
      </pre>
    </>
  );
}
